import { EllipsisHorizontalIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";
import AppButton from "../../../ui/buttons/AppButton";
import MenuButton, { type MenuSection } from "../../../ui/overlays/MenuButton";

/** The "⋯" button that opens a group's menu (`groupMenuSections`), on its row and on its screen. */
export default function GroupMenu({ name, sections, disabled }: { name: string; sections: readonly MenuSection[]; disabled: boolean }) {
  const { t } = useTranslation();
  return (
    <MenuButton
      align="right"
      sections={sections}
      renderTrigger={(trigger) => (
        <AppButton {...trigger} variant="ghost" size="sm" aria-label={t("access.groupMenu", { group: name })} disabled={disabled}>
          <EllipsisHorizontalIcon className="h-4 w-4" aria-hidden="true" />
        </AppButton>
      )}
    />
  );
}
